<template>
  <WsMain>
    <template v-if="loading.fetch">
      <v-skeleton-loader
        v-for="n in 4"
        :key="`skeleton-${n}`"
        type="list-item-three-line"
        :tile="true"
        class="mt-5"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <WsMultiList
        v-if="state&&state.length"
        :value="state"
        v-bind="fields.multiList"
        :iconControlKey="fields.multiList.iconControlKey"
      >
        <template v-slot:top-btns>
          <div class="d-flex mb-6">
            <div
              v-for="(item,btnIndex) in customBtns"
              :key="`btn_${btnIndex}`"
              class="mx-2"
            >
              <WsBtn
                :color="item.color"
                item.type
                :outlined="item.outlined"
                :to="item.to"
                @click="$_onCustom(item)"
              >
                <v-icon left>{{item.icon}}</v-icon> {{item.title}}
              </WsBtn>
            </div>
          </div>
        </template>
      </WsMultiList>
      <template v-else>
        <WsTitle>尚未設定子地區</WsTitle>
      </template>
    </template>
    <WsSortDialogGeneral
      ref="sortDialog"
      :title="'變更順序'"
      :modelName="'industry_category'"
      :getLayersKey="fields.sortDialog.getLayersKey"
      :errorMessages="fields.sortDialog.errorMessages"
      :getUrl="fields.sortDialog.getUrl"
      @updateSort="$_fetchData()"
    />
  </WsMain>
</template>
<script>
export default {
  data() {
    return {
      state: [],
      loading: {
        fetch: false,
      },
      fields: {
        multiList: {
          textKey: "name",
          icon: "mdi-domain",
          iconControlKey: "industry_categories",
          layerFields: [
            {
              modelKey: "industry_categories",
              textKey: "name",
              icon: "mdi-domain",
              iconControlKey: "industry_categories",
              innerFields: [
                {
                  modelKey: "industry_categories",
                  textKey: "name",
                },
              ],
            },
          ],
        },
        sortDialog: {
          errorMessages: ["尚未新增子地區"],
          getLayersKey: 'industry_categories',
          getUrl: 'industry_category_sequence',
        }
      },
      customBtns: [
        {
          title: `編輯子產業類別`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-pencil",
          to: `/industry_category/${this.$route.params.id}/industry_categories/update`,
        },
        {
          title: `變更順序`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-compare-horizontal",
          action: '$_onSortOpen'
        },
      ],
    };
  },
  mounted() {
    this.$_fetchData();
  },
  methods: {
    async $_fetchData() {
      try {
        this.loading.fetch = true;
        const res = await this.$axios.get(`/industry_category/${this.$route.params.id}`);
        this.state = res.data.data.industry_categories;
        this.loading.fetch = false;
      } catch (err) {
        this.loading.fetch = false;
      }
    },
    $_onCustom(item) {
      if (item.action) {
        this[item.action]()
      }
    },
    async $_onSortOpen() {
      this.$refs.sortDialog.open();
    },
  },
};
</script>